/**
 * Created by lihanying on 2017/7/6.
 */
import { API_DOMAIN } from '../../config'
import 'whatwg-fetch'
import { fetchData, postData } from '../../util/index'
import { message } from 'antd'
import { GETACCOUNTLIST, GETCLUBROLELIST, GETREGIONLIST } from './constants'

export const getAccountList = (payload) => {
  return {
    type: GETACCOUNTLIST,
    payload,
  }
}

export const getClubRoleList = (payload) => {
  return {
    type: GETCLUBROLELIST,
    payload,
  }
}

export const getRegionList = (payload) => {
  return {
    type: GETREGIONLIST,
    payload,
  }
}

//用户列表
export function fetchAccountList() {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/Home/BackstageApi/BackstageList`
    return fetchData(endpoint).then((data) => {
      dispatch(getAccountList(data.list))
      return data
    })
  }
}
export function fetchDelAccount(id) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/BackstageApi/DelBackstage/id/${id}`
    return fetchData(endpoint).then((data) => {
      if (data.status === true) {
        message.success(data.detail)
        dispatch(fetchAccountList())
      } else {
        message.error(data.detail)
      }
    })
  }
}

//修改
export function fetchEditAccount(body) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/BackstageApi/EditBackstage`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      if (data.status === true) {
        message.success(data.detail)
        dispatch(fetchAccountList())
      } else {
        message.error(data.detail)
      }
    })
  }
}
//增加
export function fetchAddAccount(body) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/BackstageApi/AddBackstage`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      if (data.status === true) {
        dispatch(fetchAccountList())
        message.success(data.detail)
      } else {
        message.error(data.detail)
      }
    })
  }
}

//角色列表
export function fetchRoleList() {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/BackstageApi/ClubRoleList`
    return fetchData(endpoint).then((data) => {
      dispatch(getClubRoleList(data.roles))
    })
  }
}

//获取地区列表
export function fetchRegionList(cb) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/LoginApi/regionList`
    return postData(endpoint, 'POST').then((data) => {
      dispatch(getRegionList(data.detail))
    })
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubUsers/action.js